import beginningGenerator from './beginningGenerator';

export default beginningGenerator([
    'schickte',
    'schickst',
    'schickt',
    'schickt',
    'schicken',
    'schickt',
    'schicken',
//
    'schenke',
    'schenkst',
    'schenkt',
    'schenkt',
    'schenken',
    'schenkt',
    'schenken',
//
    'zeige',
    'zeigst',
    'zeigt',
    'zeigt',
    'zeigen',
    'zeigt',
    'zeigen',
//
    'gebe',
    'gibst',
    'gibt',
    'gibt',
    'geben',
    'gebt',
    'geben'
]);



/** WEBPACK FOOTER **
 ** ./generator/randomPhrase/dativeBeginnings.js
 **/